<template>
  <div>
    <div class="info-stream-row">
      <!-- Stream source-->
      <div class="field source-field">
        <span
          :title="titleStatus"
          :class="{
            green: shangeSourceStatus == 'ONLINE',
            disabled: shangeSourceStatus == 'OFFLINE',
            yellow: shangeSourceStatus == 'UNKNOWN',
            'server-status': true
          }"
        >
          &#9679;
        </span>
        <el-button size="mini" type="info" @click="showSourceModal"
          >Info</el-button
        >
      </div>
      <!-- Stream recorder -->
      <div class="field recorder-field">
        <span
          :title="titleRecorder"
          :class="{
            disabled: ['STOPPED', 'ERROR', 'UNKNOWN'].includes(
              shangeRecorderStatus
            ),
            yellow: ['INITIALIZING', 'RECONNECTING'].includes(
              shangeRecorderStatus
            ),
            green: shangeRecorderStatus == 'RECORDING',
            'server-status': true
          }"
        >
          &#9679;
        </span>
        <el-button size="mini" type="info" @click="showRecorderModal"
          >Info</el-button
        >
      </div>
      <!-- Stream name -->
      <div class="field name-field stream-name">
        <!-- <span>{{ parsedStreamName }} ({{ channelName }})</span> -->
        <span>{{streamInfo.streamDisplayName}}</span>
      </div>
      <!-- Stream type -->
      <div class="field type-field">
        <span>{{ streamInfo.channelType }}</span>
      </div>
      <!-- Stream URL -->
      <div class="field url-field">
        <span>
          <a :href="streamInfo.streamUrl">
            {{ streamInfo.streamUrl }}
          </a>
        </span>
      </div>
      <!-- Stream clips -->
      <div class="field url-field">
        <span>
          {{ streamInfo.videoCount }}
        </span>
      </div>
      <!-- Action buttons -->
      <div class="field actions-field stream-actions">
        <information class="stream-action-btn info" @click="showStreamInfo" />
        <pencil class="stream-action-btn edit" @click="editStream" />
        <delete class="stream-action-btn delete" @click="removeStream" />
      </div>
    </div>
  </div>
</template>

<script>
import Information from "vue-material-design-icons/Information.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import Delete from "vue-material-design-icons/Delete.vue";
import { mapActions } from "vuex";

// @group Admin Page
// Stream row
export default {
  name: "StreamInfo",
  components: {
    Information,
    Pencil,
    Delete
  },
  props: {
    streamInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      updateServerInfoFlag: true
    };
  },
  computed: {
    shangeSourceStatus() {
      return this.streamInfo.lastSourceStatus;
    },
    shangeRecorderStatus() {
      return this.streamInfo.lastRecorderStatus;
    },
    statusTime() {
      const dataTime = this.streamInfo.statusTimestamp;
      const date = new Date(Number(dataTime));
      return date;
    },
    titleStatus() {
      if (this.streamInfo.lastSourceStatus == "ONLINE") {
        return "Online";
      } else if (this.streamInfo.lastSourceStatus == "OFFLINE") {
        return "Offline";
      } else {
        return "Unknown";
      }
    },
    titleRecorder() {
      if (this.streamInfo.lastRecorderStatus == "STOPPED") {
        return "Stopped";
      } else if (this.streamInfo.lastRecorderStatus == "INITIALIZING") {
        return "Initializing";
      } else if (this.streamInfo.lastRecorderStatus == "RECORDING") {
        return "Recording";
      } else if (this.streamInfo.lastRecorderStatus == "RECONNECTING") {
        return "Reconnecting";
      } else if (this.streamInfo.lastRecorderStatus == "ERROR") {
        return "Error";
      } else {
        return "Unknown";
      }
    },
    // @vuese
    // Channel name or placeholder
    channelName() {
      return this.streamInfo.channelName ?? "---";
    },
    // @vuese
    // Stream name without .stream
    parsedStreamName() {
      const name = this.streamInfo.streamName;

      if (!name) return "---";

      const namePattern = /^(?<name>.+).stream$/;
      const match = namePattern.exec(name);

      if (!match) return name;
      return match.groups.name;
    }
  },

  methods: {
    ...mapActions("admin", ["initServers"]),
    showSourceModal() {
      this.updateServerInfoFlag = !this.updateServerInfoFlag;
      this.$emit("updateServerInfoFlag", this.updateServerInfoFlag);
      this.$emit("showSource", this.streamInfo);
    },
    showRecorderModal() {
      this.updateServerInfoFlag = !this.updateServerInfoFlag;
      this.$emit("updateServerInfoFlag", !this.updateServerInfoFlag);
      this.$emit("showRecorder", this.streamInfo);
    },
    // @vuese
    // Call stream info action handler
    showStreamInfo() {
      this.$emit("showStreamInfo", this.streamInfo);
    },
    // @vuese
    // Call edit stream action handler
    editStream() {
      this.$emit("editStream", this.streamInfo);
    },
    // @vuese
    // Call remove stream action handler
    removeStream() {
      this.$emit("removeStream", this.streamInfo);
    }
  }
};
</script>

<style scoped>
.info-stream-row {
  display: flex;
}

.server-status {
  font-size: 1rem;

  color: var(--success-color);
}
.server-status.green {
  color: var(--success-color);
}
.server-status.disabled {
  color: var(--error-color);
}
.server-status.yellow {
  color: rgba(255, 168, 0, 0.7);
}

.field {
  text-align: center;
  font-family: var(--sans-font);
}
.status-field {
  width: 60px;
}
.source-field {
  width: 140px;
}
.recorder-field {
  width: 180px;
}
.name-field {
  width: 130px;

  /** long name ellipsis */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.type-field {
  width: 120px;
}
.url-field {
  width: 100px;
  flex-grow: 1;

  /** long URL ellipsis */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-button--info {
  background-color: #909399;
  border-color: #909399;
}
.actions-field {
  width: 100px;
}
.stream-action-btn {
  cursor: pointer;
}
.stream-action-btn.info:hover svg {
  color: blue;
}
.stream-action-btn.edit:hover svg {
  color: orange;
}
.stream-action-btn.delete:hover svg {
  color: red;
}

@media only screen and (max-width: 400px) {
  .type-field {
    display: none;
  }
}

@media only screen and (max-width: 500px) {
  .name-field {
    flex-grow: 1;
    text-align: center;
  }
  .status-field {
    text-align: center;
    padding: 0 12px 0 0px;
    width: 40px;
  }
  .url-field {
    display: none;
  }
}

@media only screen and (max-width: 640px) {
  .info-stream-row {
    font-size: var(--small-font-sz);
  }
}
</style>
